import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  z-index: 1;
  align-items: center;
  padding: 40px 0px 80px 0px;
  background: rgba(30, 30, 60, 0.55);
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.22);
  backdrop-filter: blur(10px) saturate(180%);
  border-radius: 36px;
  @media (max-width: 960px) {
    padding: 0px;
  }
`;

export const Wrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  width: 100%;
  max-width: 1200px;
  padding: 80px 0;
  gap: 32px;
  @media (max-width: 960px) {
    flex-direction: column;
    padding: 32px 0;
    gap: 18px;
  }
`;

export const Title = styled.div`
  font-size: 52px;
  text-align: center;
  font-weight: 800;
  margin-top: 20px;
  background: linear-gradient(135deg, ${({ theme }) => theme.primary}, #00d4ff, #ff6b6b, ${({ theme }) => theme.primary});
  background-size: 300% 300%;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-fill-color: transparent;
  text-shadow: 0 4px 32px ${({ theme }) => theme.primary + '66'};
  animation: titleGlow 4s ease-in-out infinite, titleShift 6s ease-in-out infinite;
  @keyframes titleGlow {
    0%, 100% { filter: drop-shadow(0 0 20px ${({ theme }) => theme.primary + '44'}); }
    50% { filter: drop-shadow(0 0 40px ${({ theme }) => theme.primary + '88'}); }
  }
  @keyframes titleShift {
    0% { background-position: 0% 50%; }
    50% { background-position: 100% 50%; }
    100% { background-position: 0% 50%; }
  }
  @media (max-width: 768px) {
    margin-top: 12px;
    font-size: 38px;
  }
`;

export const Desc = styled.div`
  font-size: 22px;
  text-align: center;
  max-width: 700px;
  color: ${({ theme }) => theme.text_secondary};
  font-weight: 500;
  margin-bottom: 24px;
  background: rgba(30,30,60,0.22);
  border-radius: 18px;
  padding: 12px 18px;
  box-shadow: 0 2px 12px ${({ theme }) => theme.primary + '22'};
  @media (max-width: 768px) {
    margin-top: 12px;
    font-size: 16px;
    padding: 8px 10px;
  }
`;

export const TimelineWrapper = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding-left: 40px;
  min-height: 100px;
  @media (max-width: 900px) {
    flex-direction: column;
    align-items: center;
    padding-left: 0;
  }
  &::before {
    content: '';
    position: absolute;
    left: 24px;
    top: 0;
    bottom: 0;
    width: 4px;
    background: linear-gradient(180deg, ${({ theme }) => theme.primary} 0%, ${({ theme }) => theme.card_light} 100%);
    border-radius: 2px;
    z-index: 0;
  }
`;

export const TimelineContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const TimelineSide = styled.div`
  flex: 0 0 320px;
  min-height: 100px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 40px;
  @media (max-width: 900px) {
    display: none;
  }
`;

export const TimelineAnimation = styled.div`
  width: 220px;
  height: 220px;
  border-radius: 24px;
  background: radial-gradient(circle at 60% 40%, ${({ theme }) => theme.primary + '33'} 0%, ${({ theme }) => theme.card_light} 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  animation: pulse 2.5s infinite alternate;
  @keyframes pulse {
    0% { box-shadow: 0 0 32px ${({ theme }) => theme.primary + '22'}; }
    100% { box-shadow: 0 0 64px ${({ theme }) => theme.primary + '66'}; }
  }
`;
